import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=6ae34b17&scoped=true"
import script from "./SurveyDetail.vue?vue&type=script&lang=js"
export * from "./SurveyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae34b17",
  null
  
)

export default component.exports